<div class="wrapper">
  <div class="container-fluid">

    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript: void(0);" routerLink="/management/participant">Participant</a></li>
              <li class="breadcrumb-item active">Edit Sink Node Mappings</li>
            </ol>
          </div>
          <h4 class="page-title">Edit Sink Node Mappings</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->

    <div class="row">
      <div class="col-12">
        <div class="card-box">
          <div class="row" >
            <div class="col-12 pb-3">
              <button *ngIf="hasAvailableSinkNodes && hasAvailableMapDescription" type="button" class="btn btn-icon waves-effect waves-light btn-outline-primary float-right" (click)="showCreateDialog()"> <i class="mdi mdi-plus"></i> Add Sink Node Mapping</button>
              <span *ngIf="!hasAvailableSinkNodes && hasAvailableMapDescription" class="error-text">All available sink nodes have been used</span>
              <span *ngIf="!hasAvailableMapDescription && hasAvailableSinkNodes" class="error-text">All available map descriptions have been used</span>
              <span *ngIf="!hasAvailableSinkNodes && !hasAvailableSinkNodes" class="error-text">All available sink nodes & map descriptions have been used</span>
            </div>
          </div>
          <div class="col-12">
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped mb-0">
              <thead>
              <tr>
                <th>Mapping Id</th>
                <th>Map Description</th>
                <th>Sink Node</th>
                <th>Postillion Id</th>
                <th class="text-right">Actions</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let mappedField of sinkNodeParticipantMappingConfigs; let i = index;">
                <td>{{ mappedField.mappingId }}</td>
                <td>{{ mapDescriptionForId(mappedField.mappingId).mapDescription }}</td>
                <td>{{ mappedField.sinknode }}</td>
                <td>{{ mappedField.participantId }}</td>
                <td>
                  <button *ngIf="canEdit" type="button" class="btn btn-icon waves-effect waves-light btn-outline-primary fa-pull-right ml-1" (click)="openEditDialog(mappedField)">
                    <i class="mdi mdi-pencil-box-outline"></i>
                    Edit
                  </button>
                  <button *ngIf="canEdit" type="button" class="btn btn-icon waves-effect waves-light btn-outline-primary fa-pull-right" (click)="openDeleteConfirmDialog(mappedField)">
                    <i class="mdi mdi-delete"></i>
                    Delete
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
